import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { useChatContext } from '../context/useChatContext.js';

function SuperAdminRoute({ children }) {
  const { isSuperAdmin } = useChatContext();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Aguardar a definição do papel na inicialização
  if (isSuperAdmin === null) {
    return (
      <div className="app-boot-loading">
        <div className="app-boot-loading__content">Carregando perfil...</div>
      </div>
    );
  }

  if (isSuperAdmin !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default SuperAdminRoute;
